import { render, staticRenderFns } from "./ItemMasterActiveWorkflowsSection.vue?vue&type=template&id=7ce581ce&scoped=true&"
import script from "./ItemMasterActiveWorkflowsSection.vue?vue&type=script&lang=js&"
export * from "./ItemMasterActiveWorkflowsSection.vue?vue&type=script&lang=js&"
import style0 from "./ItemMasterActiveWorkflowsSection.vue?vue&type=style&index=0&id=7ce581ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce581ce",
  null
  
)

export default component.exports